import { useCallback } from 'react'

import { resetEditingState } from '@/atoms'
import { useAppDispatch } from '@/store'
import { updateTrafficProfile } from '@/features/domain/traffic'
import { useTexts } from './useTexts'
import { normalizeFormValues } from '../utils/formValues'
import { FormValues } from '../types'
import { useController } from './useController'
import { useNotification } from '@/hooks'

export function useOnSubmit(sourceTrafficProfile: uui.domain.client.rm.TrafficProfile) {
  const dispatch = useAppDispatch()
  const toast = useNotification()

  const { updateData, close } = useController()

  const texts = useTexts()

  return useCallback(
    async (formValues: FormValues) => {
      try {
        updateData({ submitting: true })

        const trafficProfile = normalizeFormValues(formValues, sourceTrafficProfile)
        const thunkResult = await dispatch(updateTrafficProfile(trafficProfile))
        updateData({ submitting: false })

        if (updateTrafficProfile.rejected.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        toast.success(texts.toast.success)

        resetEditingState()
        close?.()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [dispatch, resetEditingState, toast, close, sourceTrafficProfile, updateData, texts],
  )
}
